// extracted by mini-css-extract-plugin
export default {"adminstudent":"AdminStudentProcess_adminstudent__gnq8f","adminstudent__container":"AdminStudentProcess_adminstudent__container__ee+Oa"};